import {formatDateTime} from '@/utils/format';

export default {
  data () {
    return {
      stockRentDate: '',
      stockRentDateOption: {},
      disabledRentDate: false,
    }
  },
  watch: {
    stockRentDate: {
      handler: function (value) {
        this.data['stockRentDate'] = formatDateTime(value, false);
      }
    },
    'data.stockStatus': {
      handler: function (value) {
        if (value === 0) {
          this.stockRentDate = new Date();
          this.disabledRentDate = true;
          this.stockRentDateOption = {
            disabledDate(date) {
            },
          };
        } else if (value === 3) {
          this.stockRentDate = null;
          this.disabledRentDate = false;
          this.stockRentDateOption = {
            disabledDate(date) {
              return date && (date.valueOf() < Date.now() - 86400000);
            },
          };
        }
      },
      deep: true,
    }
  },
  methods: {
    validateDate(rule, value, callback) {
      if (!value) callback('请选择出租日期');
      callback();
    },
  }
}